import React from "react";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  // BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import EmailVerificationPage from "./pages/EmailVerificationPage";
import HomeNavbar from "./components/HomeNavbar";
import MainNavbar from "./components/MainNavbar";
import InstNavbar from "./components/InstNavbar";
import HomeFooter from "./components/HomeFooter";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import VerificationPage from "./pages/VerificationPage";
import SendPasswordResetEmailPage from "./pages/SendPasswordResetEmailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import HomePage from "./pages/HomePage";
import InstitutionPage from "./pages/InstitutionPage";
import SubjectsPage from "./pages/SubjectsPage";
import NotFoundPage from "./pages/NotFoundPage";
import TestLevelsPage from "./pages/TestLevelsPage";
import QuestionsPage from "./pages/QuestionsPage";
import ExamPage from "./pages/ExamPage";
import SubjectTheoryPage from "./pages/SubjectTheoryPage";
import TheoryYearsPage from "./pages/TheoryYearPage";
import GoldPage from "./pages/GoldPage";
import TheoryQuestionsPage from "./pages/TheoryQuestionsPage";
import PromoCodePage from "./pages/PromoCodePage";
import StudentsPage from "./pages/StudentsPage";
import PaystackStudentsPaymentPage from "./pages/PaystackStudentsPaymentPage";
import PaystackPaymentPage from "./pages/PaystackPaymentScreen";
import NewsPage from "./pages/NewsPage";
import DashboardPage from "./pages/DashboardPage";
import AdminNavbar from "./components/AdminNavbar";
import AdminExamCountryPage from "./pages/AdminExamCountryPage";
import AdminExamPage from "./pages/AdminExamPage";
import AdminEditExamPage from "./pages/AdminEditExamPage";
import AdminSubjectPage from "./pages/AdminSubjectPage";
import AdminSubjectCategoryPage from "./pages/AdminSubjectCategoryPage";
import AdminSubjectCategoryEditPage from "./pages/AdminSubjectCategoryEditPage";
import AdminEditSubjectPage from "./pages/AdminEditSubjectPage";
import AdminTestPage from "./pages/AdminTestPage";
import AdminEditTestPage from "./pages/AdminEditTestPage";
import AdminTestQuestionPage from "./pages/AdminTestQuestionPage";
import AdminEditTestQuestionPage from "./pages/AdminEditTestQuestionPage";
import AdminTestOptionPage from "./pages/AdminTestOptionPage";
import AdminEditTestOptionPage from "./pages/AdminEditOptionPage";
import AdminExamTestPage from "./pages/AdminExamTestPage";
import AdminEditExamTestPage from "./pages/AdminEditExamTestPage";
import AdminExamQuestionPage from "./pages/AdminExamQuestionPage";
import AdminEditExamQuestionPage from "./pages/AdminEditExamQuestionPage";
import AdminExamOptionPage from "./pages/AdminExamOptionPage";
import AdminEditExamOptionPage from "./pages/AdminEditExamOptionPage";
import AdminTheorySubjectpage from "./pages/AdminTheorySubjectPage";
import AdminEditTheorySubjectPage from "./pages/AdminEditTheorySubjectPage";
import AdminTheoryYearPage from "./pages/AdminTheoryYearPage";
import AdminEditTheoryYearPage from "./pages/AdminEditTheoryYearPage";
import AdminEditTheoryNumberPage from "./pages/AdminEditTheoryNumberPage";
import AdminTheoryQuestionPage from "./pages/AdminTheoryQuestionPage";
import AdminEditTheoryQuestionPage from "./pages/AdminEditTheoryQuestionPage";
import AdminNewsListPage from "./pages/AdminNewsPage";
import AdminNewsEditPage from "./pages/AdminEditNewsPage";
import AdminNewsCategoryListPage from "./pages/AdminNewsCategoryPage";
import AdminEditNewsCategoryPage from "./pages/AdminEditNewsCategoryPage";
import AdminStudentPage from "./pages/AdminStudentPage";
import AdminEditStudentPage from "./pages/AdminEditStudentPage";
import AdminPromoCodePage from "./pages/AdminPromoCodePage";
import AdminPromoInstancesPage from "./pages/AdminPromoInstancesPage";
import AdminPromoInstanceDetailPage from "./pages/AdminPromoInstanceDetailPage";
import AdminLocationPage from "./pages/AdminLocationPage";
import AdminLocationWithStudentCountPage from "./pages/AdminLocationWithStudentCountPage";
import AdminCountryPage from "./pages/AdminCountryPage";

import AdminGoldPage from "./pages/AdminGoldPage";
import DeleteAccountPage from "./pages/DeleteAccountPage";

import InstHomePage from "./pages/InstHomePage";
import InstProfilePage from "./pages/InstProfilePage";
// import TloginPage from "./pages/TloginPage";
import InstClassForm from "./pages/InstClass";

import InstQuestionsPage from "./pages/InstQuestionsPage";
import "katex/dist/katex.min.css";
import InstSubjectPage from "./pages/InstSubjectPage";
import ActivityPage from "./pages/ActivityPage";
// import StudentCodeLogin from "./pages/StudentCodeLogin";
// import InstAdminClass from "./pages/instAdminclass";
import ClassTermStudents from "./pages/InstAdminClassTermStudentsReport";
import ProductListPage from "./storePages/ProductListPage";
import ProductDetailPage from "./storePages/ProductDetailPage";
import CheckoutPage from "./storePages/CheckoutPage";
import PaystackProductPaymentScreen from "./storePages/PaystackProductPaymentScreen ";
import SubscriptionPlans from "./pages/InstSubPlans";
import InstNotificationsPage from "./pages/InstNotifications";
import LiteUpperProposalPage from "./pages/LiteUpperProposalPage";
import PrivacyPage from "./pages/privacy-page";
import NotificationsPage from "./pages/NotificationsPage";
import ProfilePageFile from "./pages/Profile-page";
import ReferralPage from "./pages/referral-page";

import PromoCodeDashBoard from "./pages/PromoCodeDashboard";
import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import StudentCodeLogin from "./pages/StudentCodeLogin";
import SubjectsScreen from "./pages/SubjectScreen";
import TLoginPage from "./pages/Tlogin";
import ExamStudentPage from "./pages/ExamStudentPage";
import WaecSubjectScreen from "./pages/waecSubjectPage";
import WaecExamPage from "./pages/WaecPastQuestionTest";
import WaecExamTheoryPage from "./pages/WaecExamTheoryPage";
import JambSubjectsScreen from "./pages/JambSubjectScreen";
import JambExamPage from "./pages/JambExamPage";
import StudentAnalysisPage from "./pages/analysis/studetAnalysisPage";
import SubjectAnalysisPage from "./pages/analysis/subjectAnalysisPage";

import SubjectsPageAdmin from "./pages/SubjectPageAdmin";

import AnalysisDashboard from "./pages/analysis/analysisPage";
import ClassAnalysisPage from "./pages/analysis/classAnalysisPage";
import VideosPage from "./pages/videoPageAdmin";
import SubjectsPageHome from "./pages/SubjectPageHome";
import VideoPlayer from "./pages/VideoPlayerPage";
import VideosPageHome from "./pages/VideoPageHome";
import RegularStudentLogin from "./pages/RegularStudentLogin";
import RegularStudentAnalysisPage from "./pages/analysis/regularStudentAnalysisPage";
import VideoCategoriesPage from "./pages/VideosCategoriesPage";
import VideoStatsPageAdmin from "./pages/VideoStatsPageAdmin";
import InstAssignmentPage from "./pages/instAssignmentPage";
import RegularStudentLoginAssignment from "./pages/studentAssignmentLoginPage";
import StudentAssignmentHome from "./pages/studentAssignment";
import StudentAssignmentPage from "./pages/studentAssignmentPage";
import StudentPortal from "./pages/studentPortal";
import OnlineTeacherStatsPage from "./pages/OnlineTeacherStatsPage";


const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "*": {
          scrollbarWidth: "thin",
          scrollbarColor: "#0288D1 #0a1628",
        },
        "*::-webkit-scrollbar": { width: "6px", height: "6px" },
        "*::-webkit-scrollbar-track": {
          background: "#080f1e",
          borderRadius: "99px",
        },
        "*::-webkit-scrollbar-thumb": {
          background:
            "linear-gradient(180deg, #0ea5e9 0%, #0288D1 50%, #7c3aed 100%)",
          borderRadius: "99px",
          border: "1px solid rgba(255,255,255,0.05)",
        },
        "*::-webkit-scrollbar-thumb:hover": {
          background:
            "linear-gradient(180deg, #38bdf8 0%, #0ea5e9 50%, #a78bfa 100%)",
        },
        "*::-webkit-scrollbar-corner": { background: "#080f1e" },
      },
    },
  },
});
const App = () => {
  const location = useLocation(); // Get current route

  // Paths where HomeNavbar should not be shown
  const shouldHideNavbar = [
    "/teachers-login",
    "/login",
    "/register",
    "/reset-password",
    "/send-reset-password",
    "/first-update-profile",
    "/secUpdateProfile",
    "/instclass",
    "/instsub",
    "/instquestion",
    "/instassignment",
    "/activities",
    "/student-login",
    "/subjects-screen",
    "/student-exam",
    "/waec-subject-page",
    "/waec-questions",
    "/waec-theory",
    "/jamb-subjects",
    "/jamb-exams",
    "/regular-student-login",
    "/student-assignment-login",
    "/verification",
    "/verify",
    "/student-assignments",
    "/student-assignment",
    "/student-portal",
  ].some((path) => location.pathname.startsWith(path));

  // Paths that should use MainNavbar
  const isMainNavbar = [
    "/institutions",
    "/subjects",
    "/tests",
    "/questions",
    "/Exam",
    "/subjects-theory",
    "/theory-years",
    "/golds",
    "/theory-numbers",
    "/theory-questions",
    "/profile",
    "/promo-code",
    "/students",
    "/news",
    "/home",
    "/delete-account",
    "/paystack-payment",
    "/PaystackStudentsPayment",
    "/notifications",
    "/referral",
    "/subjects-screen",
    "/student-exam",
    "/waec-subject-page",
    "/waec-questions",
    "/waec-theory",
    "/jamb-subjects",
    "/jamb-exams",
    "/home/subjects",
    "/videos/",
    "/student-analysis",
    "/teacher/video-stats"
  ].some((path) => location.pathname.startsWith(path));

  // Admin Navbar
  const isAdminNavbar = [
    "/dashboard",
    "/admin-news-country",
    "/admin-exam-country",
    "/admin-exam",
    "/admin-edit-exam",
    "/admin-subject",
    "/admin-subject-category",
    "/admin-edit-category",
    "/admin-edit-subject",
    "/admin-test",
    "/admin-edit-test",
    "/admin-test-question",
    "/admin-edit-test-question",
    "/admin-test-options",
    "/admin-edit-test-option",
    "/admin-exam-test",
    "/admin-edit-exam-test",
    "/admin-exam-questions",
    "/admin-edit-exam-question",
    "/admin-exam-options",
    "/admin-edit-exam-option",
    "/admin-video-country",
    "/admin-theory-subject",
    "/admin-edit-theory-subject",
    "/admin-theory-year",
    "/admin-edit-theory-year",
    "/admin-edit-theory-number",
    "/admin-theory-question",
    "/admin-edit-theory-question",
    "/admin-news-list",
    "/admin-edit-news",
    "/admin-news-categories",
    "/admin-edit-news-category",
    "/admin-student",
    "/admin-edit-student",
    "/admin-promo-code",
    "/admin-promo-instance",
    "/admin-promo-instance-detail",
    "/admin-location-country",
    "/admin-location",
    "/admin-location-count",
    "/admin-country",
    "/admin-gold-country",
    "/admin-golds",
    "/admin-video",
    "/admin-video-categories",
    "/admin/video-stats-page",
  ].some((path) => location.pathname.startsWith(path));

  // Institution Navbar
  const isInstNavbar = [
    "/insthome",

    "/instprofile",
    "/instadminclass",
    "/instaminstudreport",
    "/products",
    "/product/detail",
    "/cart",
    "/paystack-products",
    "/instnotifications",
    "/inst-sub-plans",
    "/subjects-screen",
    "/student-exam",
    "/waec-subject-page",
    "/waec-questions",
    "/waec-theory",
    "/jamb-subjects",
    "/jamb-exams",
    "/analysis-dashboard",
    "/analysis/student",
    "/analysis/subject",
    "/analysis/class",
  ].some((path) => location.pathname.startsWith(path));

  const shouldHideFooter = [
    "/student-login",
    "/teachers-login",
    "/login",
    "/register",
    "/subjects-screen",
    "/student-exam",
    "/waec-subject-page",
    "/waec-questions",
    "/waec-theory",
    "/jamb-subjects",
    "/jamb-exams",
    "/reset-password",
    "/regular-student-login",
    "/student-assignment-login",
    "/send-reset-password",
    "/verification",
    "/verify",
    "/student-portal",
    "/student-assignments",
    "/student-assignment",
  ].some((path) => location.pathname.startsWith(path));

  // Final return
  return (
    <div id="root">
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastContainer position="bottom-right" />

        {!shouldHideNavbar &&
          (isAdminNavbar ? (
            <AdminNavbar />
          ) : isMainNavbar ? (
            <MainNavbar />
          ) : isInstNavbar ? (
            <InstNavbar />
          ) : (
            <HomeNavbar />
          ))}

        <div className="main-content">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/verification" element={<VerificationPage />} />
            <Route path="/verify" element={<EmailVerificationPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/student-login" element={<StudentCodeLogin />} />
            <Route
              path="/send-reset-password"
              element={<SendPasswordResetEmailPage />}
            />
            <Route path="/home" element={<HomePage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            {/* <Route path="/admin-country" element={<CountryPage />} /> */}
            <Route
              path="/admin-student/:countryId"
              element={<AdminStudentPage />}
            />{" "}
            <Route
              path="/admin-promo-code/:countryId"
              element={<PromoCodeDashBoard />}
            />
            <Route path="/golds" element={<GoldPage />} />
            <Route path="/subjects/:examId" element={<SubjectsPage />} />
            <Route
              path="/tests/:examId/:subjectId"
              element={<TestLevelsPage />}
            />
            <Route
              path="/Exam/:examId/:subjectId/:testId"
              element={<ExamPage />}
            />
            <Route
              path="/questions/:examId/:subjectId/:testId"
              element={<QuestionsPage />}
            />
            <Route
              path="/subjects-theory/:examId"
              element={<SubjectTheoryPage />}
            />
            <Route
              path="/theory-years/:examId/:theorySubjectId"
              element={<TheoryYearsPage />}
            />
            <Route
              path="/theory-questions/:theoryYearId/"
              element={<TheoryQuestionsPage />}
            />
            <Route path="*" element={<NotFoundPage />} />
            <Route path="/institutions" element={<InstitutionPage />} />
            <Route path="/profile" element={<ProfilePageFile />} />
            <Route path="/referral" element={<ReferralPage />} />
            <Route path="/promo-code" element={<PromoCodePage />} />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/paystack-payment" element={<PaystackPaymentPage />} />
            <Route
              path="/PaystackStudentsPayment"
              element={<PaystackStudentsPaymentPage />}
            />
            <Route
              path="/admin-exam-country"
              element={<AdminExamCountryPage page={"admin-exam"} />}
            />
            <Route
              path="/admin-video-country"
              element={<AdminExamCountryPage page={"admin-subject-videos"} />}
            />
            <Route path="/admin-exam/:countryId" element={<AdminExamPage />} />
            <Route path="/admin-subject-videos/:countryId" element={<SubjectsPageAdmin />} />
            <Route
              path="/admin-edit-exam/:examId"
              element={<AdminEditExamPage />}
            />
            <Route
              path="/admin-subject/:examId"
              element={<AdminSubjectPage />}
            />
            <Route
              path="/admin-edit-subject/:subjectId"
              element={<AdminEditSubjectPage />}
            />
            <Route
              path="/admin-subject-category"
              element={<AdminSubjectCategoryPage />}
            />
            <Route
              path="/admin-edit-category/:categoryId"
              element={<AdminSubjectCategoryEditPage />}
            />
            <Route path="/admin-test/:subjectId" element={<AdminTestPage />} />
            <Route
              path="/admin-edit-test/:testId"
              element={<AdminEditTestPage />}
            />
            <Route
              path="/admin-test-question/:testId"
              element={<AdminTestQuestionPage />}
            />
            <Route
              path="/admin-edit-test-question/:questionId"
              element={<AdminEditTestQuestionPage />}
            />
            <Route
              path="/admin-test-options/:questionId"
              element={<AdminTestOptionPage />}
            />
            <Route
              path="/admin-edit-test-option/:optionId"
              element={<AdminEditTestOptionPage />}
            />
            <Route
              path="/admin-exam-test/:subjectId"
              element={<AdminExamTestPage />}
            />
            <Route
              path="/admin-edit-exam-test/:testId"
              element={<AdminEditExamTestPage />}
            />
            <Route
              path="/admin-exam-questions/:testId"
              element={<AdminExamQuestionPage />}
            />
            <Route
              path="/admin-edit-exam-question/:questionId"
              element={<AdminEditExamQuestionPage />}
            />
            <Route
              path="/admin-exam-options/:questionId"
              element={<AdminExamOptionPage />}
            />
            <Route
              path="/admin-edit-exam-option/:optionId"
              element={<AdminEditExamOptionPage />}
            />
            <Route
              path="/admin-theory-subject/:examId"
              element={<AdminTheorySubjectpage />}
            />
            <Route
              path="/admin-edit-theory-subject/:theorySubjectId"
              element={<AdminEditTheorySubjectPage />}
            />
            <Route
              path="/admin-theory-year/:theorySubjectId"
              element={<AdminTheoryYearPage />}
            />
            <Route
              path="/admin-edit-theory-year/:theoryYearId"
              element={<AdminEditTheoryYearPage />}
            />
            {/* <Route
              path="/admin-theory-numbers/:theoryYearId"
              element={<AdminTheoryNumberPage />}
            /> */}
            <Route
              path="/admin-edit-theory-number/:theoryNumberId"
              element={<AdminEditTheoryNumberPage />}
            />
            <Route
              path="/admin-theory-question/:theoryYearId"
              element={<AdminTheoryQuestionPage />}
            />
            <Route
              path="/admin-edit-theory-question/:theoryQuestionId"
              element={<AdminEditTheoryQuestionPage />}
            />
            <Route
              path="/admin-news-country"
              element={<AdminExamCountryPage page={"admin-news-list"} />}
            />
            <Route
              path="/admin-news-list/:countryId"
              element={<AdminNewsListPage />}
            />
            <Route
              path="/admin-edit-news/:newsId"
              element={<AdminNewsEditPage />}
            />
            <Route
              path="/admin-news-categories/"
              element={<AdminNewsCategoryListPage />}
            />
            <Route
              path="/admin-edit-news-category/:categoryId"
              element={<AdminEditNewsCategoryPage />}
            />
            <Route
              path="/admin-student-country"
              element={<AdminExamCountryPage page={"admin-student"} />}
            />
            <Route
              path="/admin-edit-student/:studentId"
              element={<AdminEditStudentPage />}
            />
            <Route
              path="/admin-promo-country"
              element={<AdminExamCountryPage page={"admin-promo-code"} />}
            />
            <Route path="/admin-promo-code" element={<AdminPromoCodePage />} />
            <Route
              path="/admin-promo-instance"
              element={<AdminPromoInstancesPage />}
            />
            <Route
              path="/admin-promo-instance-detail/:date"
              element={<AdminPromoInstanceDetailPage />}
            />
            <Route
              path="/admin-location/:countryId"
              element={<AdminLocationPage />}
            />
            <Route
              path="/admin-location-count"
              element={<AdminLocationWithStudentCountPage />}
            />
            <Route path="/admin-country" element={<AdminCountryPage />} />
            <Route
              path="/admin-gold-country"
              element={<AdminExamCountryPage page={"admin-golds"} />}
            />
            <Route
              path="/admin-location-country"
              element={<AdminExamCountryPage page={"admin-location"} />}
            />
            <Route path="/admin-golds/:countryId" element={<AdminGoldPage />} />
            <Route path="/delete-account" element={<DeleteAccountPage />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/instnotifications" element={<NotificationsPage />} />
            <Route path="/insthome" element={<InstHomePage />} />
            <Route path="/instprofile" element={<InstProfilePage />} />
            {/* <Route path="/Tlogin" element={<TloginPage />} /> */}
            <Route path="/instclass" element={<InstClassForm />} />
            {/* <Route path="/instadminclass" element={<InstAdminClass />} /> */}
            <Route path="/instsub/:classId" element={<InstSubjectPage />} />
            <Route
              path="/instassignment/:subId"
              element={<InstAssignmentPage />}
            />
            <Route
              path="/instquestion/:subId"
              element={<InstQuestionsPage />}
            />
            <Route path="/activities" element={<ActivityPage />} />
            {/* <Route path="/Slogin" element={<StudentCodeLogin />} /> */}
            <Route path="/instaminstudreport" element={<ClassTermStudents />} />
            <Route path="/products" element={<ProductListPage />} />
            <Route path="/product/detail/:id" element={<ProductDetailPage />} />
            <Route path="/cart" element={<CheckoutPage />} />
            <Route
              path="/paystack-products"
              element={<PaystackProductPaymentScreen />}
            />
            <Route path="/inst-sub-plans" element={<SubscriptionPlans />} />
            <Route
              path="/instnotifications"
              element={<InstNotificationsPage />}
            />
            <Route
              path="/LiteupperProposal"
              element={<LiteUpperProposalPage />}
            />
            <Route path="/subjects-screen" element={<SubjectsScreen />} />
            <Route path="/teachers-login" element={<TLoginPage />} />
            <Route path="/student-exam" element={<ExamStudentPage />} />
            <Route path="/waec-subject-page" element={<WaecSubjectScreen />} />
            <Route path="/waec-questions" element={<WaecExamPage />} />
            <Route path="/waec-theory" element={<WaecExamTheoryPage />} />
            <Route path="/jamb-subjects" element={<JambSubjectsScreen />} />
            <Route path="/jamb-exams" element={<JambExamPage />} />
            {/* ANALYSIS */}
            <Route path="/analysis-dashboard" element={<AnalysisDashboard />} />
            <Route
              path="/analysis/student/:id"
              element={<StudentAnalysisPage />}
            />
            <Route
              path="/analysis/subject/:id"
              element={<SubjectAnalysisPage />}
            />
            <Route path="/analysis/class/:id" element={<ClassAnalysisPage />} />
            <Route path="/admin-subject" element={<SubjectsPageAdmin />} />
            <Route path="/admin-subject/:id/videos" element={<VideosPage />} />
            <Route path="/home/subjects" element={<SubjectsPageHome />} />
            
            <Route path="/videos/:id" element={<VideoPlayer />} />
            <Route
              path="/subjects/:subjectId/videos"
              element={<VideosPageHome />}
            />
            <Route
              path="/subjects/:subjectId/exams/:examId/videos"
              element={<VideosPageHome />}
            />
            <Route path="/admin-video/:id" element={<VideoPlayer />} />
            <Route
              path="/student-analysis/:id"
              element={<RegularStudentAnalysisPage />}
            />
            <Route
              path="/student-assignment/:subId"
              element={<StudentAssignmentPage />}
            />
            <Route
              path="/regular-student-login"
              element={<RegularStudentLogin />}
            />
            <Route
              path="/student-assignment-login"
              element={<RegularStudentLoginAssignment />}
            />
            <Route
              path="/student-assignments"
              element={<StudentAssignmentHome />}
            />
            <Route
              path="/admin-video-categories"
              element={<VideoCategoriesPage />}
            />
            <Route
              path="/teacher/video-stats"
              element={<OnlineTeacherStatsPage />}
            />
            <Route
              path="/admin/video-stats-page"
              element={<VideoStatsPageAdmin />}
            />
            <Route path="/student-portal" element={<StudentPortal />} />
          </Routes>
        </div>
        {!shouldHideFooter && <HomeFooter />}
      </ThemeProvider>
    </div>
  );
};

export default App;
